export default function Section({ 
  children, 
  className = '', 
  containerClassName = '',
  id,
  dark = false,
  light = false
}) {
  const bgClass = dark ? 'bg-blue-900 text-white' : light ? 'bg-gray-50' : 'bg-white';
  
  return (
    <section 
      id={id} 
      className={`py-16 md:py-24 ${bgClass} ${className}`}
    >
      <div className={`container mx-auto px-4 sm:px-6 lg:px-8 ${containerClassName}`}>
        {children}
      </div>
    </section>
  );
}
